module.exports = __webpack_public_path__ + "static/media/1016869.d78c6cf0.jpg";